module.exports = __webpack_public_path__ + "img/jeonpo_gallery2.529ac2a0.jpg";